import { Card, CardContent, CircularProgress, Icon, Typography } from '@material-ui/core';
import { Formik } from 'formik';
import { useHistory } from 'react-router-dom';

// local imports
import { useQuery, useSystemUserListService } from 'app/hooks/services';
import { AddButton, Breadcrumb } from 'app/components/atoms';
import { CustomDataTable } from 'app/components/organisms/table';
import { FilterSystemUsers } from 'app/components/organisms/filter-forms';
import { EnvDefaults } from 'app/utils';
import FusePageCarded from '@fuse/core/FusePageCarded';

const tableQueries = {
  limit: 25,
  skip: 0,
  orderBy: 'name',
  sortBy: 'asc',
  name: '',
  surname: ''
};

const SystemUsersList = () => {
  const history = useHistory();

  // system user service connection
  const { queries, handleFilterChange, handlePageChange, handleSort, isFilteringRef } =
    useQuery(tableQueries);

  const { service, handleRefresh } = useSystemUserListService(queries, isFilteringRef);

  // redirect add system user page
  const handleAddNewRecord = () => history.push('/user-management/add-user');

  const addButton = (
    <AddButton
      label="Kullanıcı Ekle"
      onAddNewRecord={handleAddNewRecord}
      color="secondary"
      icon="person_add"
    />
  );

  return (
    <>
      <FusePageCarded
        header={<Breadcrumb title="Kullanıcı Yönetimi" />}
        contentToolbar={
          <Typography variant="h6" className="m-0 p-24 tracking-wider font-semibold">
            Kullanıcı Listesi
          </Typography>
        }
        content={
          <div className="p-24">
            {/* Filter form */}
            <Card className="mb-16" elevation={4}>
              <CardContent>
                <div className="flex items-center">
                  <Icon>filter_list</Icon>
                  <Typography variant="subtitle1" className="text-gray-700 font-semibold mx-8">
                    Filtrele
                  </Typography>
                  {isFilteringRef.current && (
                    <CircularProgress color="secondary" size={22} thickness={6} />
                  )}
                </div>

                <Formik initialValues={EnvDefaults.filterUsersDefaults}>
                  <FilterSystemUsers handleChange={handleFilterChange} />
                </Formik>
              </CardContent>
            </Card>

            <Card elevation={3}>
              <CardContent>
                <CustomDataTable
                  defaultSortId={queries?.orderBy}
                  defaultDirection={queries?.sortBy}
                  service={service}
                  queries={queries}
                  handlePageChange={handlePageChange}
                  handleChange={handleFilterChange}
                  handleSort={handleSort}
                  addButton={addButton}
                  handleRefreshTable={handleRefresh}
                />
              </CardContent>
            </Card>
          </div>
        }
      />
    </>
  );
};

export default SystemUsersList;
